import React from 'react';
import { icons } from '~/assets';
import Dialog from '~/components/dialog';
import * as St from '~/views/Consult/User/Detail/styles';

interface WalletCardsDialogProps {
  open: boolean;
  cards: any[];
  onClose: () => void;
}

const WalletCardsDialog: React.FC<WalletCardsDialogProps> = ({
  open,
  cards,
  onClose,
}) => {
  return (
    <Dialog
      icon={icons.exclamation}
      open={open}
      title={<span style={{ color: 'red' }}> Cartões cadastrados </span>}
      positiveLabel="Voltar"
      positiveAction={onClose}
    >
      <St.TableHistory>
        <tr>
          <th>Bandeira</th>
          <th>Número do cartão</th>
          <th>Principal</th>
          <th>Validado</th>
          <th>BlackList</th>
        </tr>

        {cards?.map((item) => (
          <tr key={item.numeroCartao}>
            <td>{item.bandeira}</td>
            <td>{item.numeroCartao}</td>
            <td>{item.principal ? 'SIM' : 'NÃO'}</td>
            <td>{item.validado ? 'SIM' : 'NÃO'}</td>
            <td>{item.blackList ? 'SIM' : 'NÃO'}</td>
          </tr>
        ))}
      </St.TableHistory>
    </Dialog>
  );
};

export default WalletCardsDialog;
